<template>
    <div class="range">
        <b-container>
            <!--<b-row class="p-2">-->
                <!--<b-col class="p-2" cols="6" md="4" v-for="(model, index) of model_list" :key="index">-->
                    <!--<ModelListCard :model="model"></ModelListCard>-->
                <!--</b-col>-->
            <!--</b-row>-->

            <div class="popular_configurations" v-if="configurations_list.length > 0">
                <h5 v-if="this.$router.mode == 'history'">Popular Configurations</h5>
                <b-row class="p-2">
                    <b-col class="p-2" cols="12" sm="6" md="4" v-for="(configuration, index) of configurations_list" :key="index">
                        <ModelListCard :model="configuration"></ModelListCard>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>
<style lang="scss" scoped>
    html.mardome #daylight-app {
        padding-top: 1rem !important;
        padding-bottom: 3rem !important;
        .range {
            min-height: 100vh;
            background-color: #004E43!important;
        }
        .daylight-logo {
            max-width: 200px;
        }
    }

    #daylight-app {
        h5 {
            color: white;
            margin-top: 40px;
            font-weight: 100;
            opacity: 0.5;
            padding-bottom: 10px;
            text-transform: uppercase;
            letter-spacing: 0.1em;
        }

        &.embed {
            .range {
                & > .container {
                    background-color: #d5d5d5;
                    border-radius: 4px;
                }
            }
        }
    }
</style>
<script>
    import api from '../api';

    export default {
        name: 'Popular',
        props: {
            range_slug: {
                default: 'mardome'
            }
        },
        components: {
            'ModelListCard': () => import(/* webpackChunkName: "model-list-card" */ '../components/ModelListCard.vue'),
        },
        data() {
            return {
                model_list: [],
                configurations_list: [],
            }
        },
        created() {
            this.loadModels()
            this.loadConfigurations()
        },
        methods: {
            /**
             * Load a list of models from the API
             */
            loadModels() {
                api.getModels(this.range_slug).then(response => {
                    this.model_list = response.models;
                }).catch(error => {
                    if (error.response.status === 404) {
                        this.$router.push({name: 'range_list'})
                    }
                })
            },
            /**
             * Load a list of pre configured products from the API
             */
            loadConfigurations() {
                api.getConfigurations(this.range_slug).then(response => {
                    this.configurations_list = response.configurations;
                }).catch(error => {
                    if (error.response.status === 404) {
                        this.$router.push({name: 'range_list'})
                    }
                })
            },
        }
    }
</script>
